import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import HighlightsSection from "../../../components/HighlightsSection/HighlightsSection";

export default function GibraltariGamingLicense () {

    return (
        <main className='main'>

            <IntroSection
                title="Gibraltar iGaming License"
                subtitle="One of the World’s Most Prestigious Gaming Licenses"
                description =
                    "The <b>Gibraltar Gambling Commissioner</b> regulates <b>online gaming</b> under one of the <b>strictest</b> and <b>most respected frameworks globally</b>.
                    <br/>
                    <br/>
                    A <b>Gibraltar iGaming license</b> is a <b>Tier-1 certification</b> that gives operators <b>instant credibility</b> with <b>banks, PSPs, affiliate networks, and investors</b>. It is especially attractive for companies targeting the <b>UK, EU, and Commonwealth markets</b>.
                    "
                badges={[
                    "Online Casinos",
                    "Sportsbooks",
                    "Lotteries",
                    "Esports",
                    "B2B Suppliers"
                ]}
                buttonText="Request a Gibraltar iGaming Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/gibraltar-igaming-license-hero.png")}
                imageAlt="Gaming License Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Gibraltar for iGaming?'
                        subtitle="Operating without a license exposes your business to:"
                        blocks={[
                            {
                                items: [
                                    { title: "Tier-1 Recognition", text: "trusted worldwide, especially in the UK" },
                                    { title: "Strict & Respected Regulator", text: "Gibraltar Gambling Commissioner" },
                                    { title: "UK Market Access", text: "Gibraltar licenses are fully recognized by the UK Gambling Commission" },
                                    { title: "Prestige & Credibility", text: "banks and PSPs prefer Tier-1 gaming licenses" },
                                    { title: "Favorable Tax Regime", text: "10% corporate tax, no VAT" }
                                ]
                            }
                        ]}
                    />

                    <FeatureCards
                        title='What the License Covers'
                        subtitle='A CRA iGaming License in Western Sahara allows you to operate:'
                        features={
                            [
                                {
                                    title: "Remote Gambling License (B2C)",
                                    text: "● For operators running <b>online casinos, sportsbooks, poker, lotteries, or skill games.</b> <br/> ● Covers all verticals under <b>one umbrella license.</b>"
                                },
                                {
                                    title: "Betting Intermediary License",
                                    text: "● For <b>betting exchanges and intermediaries.</b>"
                                },
                                {
                                    title: "B2B Supplier License",
                                    text: "● For <b>gaming software developers, platforms, and service providers.</b> <br/> ● Required for firms providing solutions to licensed operators."
                                }
                            ]

                        }
                    />

                    <LocationTimeline
                        title='Capital & Requirements'
                        item={
                            [
                                { title: "Capital Requirement", text: "case by case, typically GBP 100k–500k" },
                                { title: "Entity", text: "Gibraltar-incorporated company required" },
                                { title: "Resident Presence", text: "local management and compliance officer required" },
                                { title: "Office", text: "physical office in Gibraltar mandatory" },
                                { title: "Compliance", text: "AML/KYC frameworks, responsible gambling standards" },
                                { title: "Audit", text: "annual financial and compliance audits" }
                            ]
                        }
                    />

                    {/* Services */}
                    <ServiceCards
                        title='Benefits of Gibraltar iGaming License'
                        services={
                            [
                                { title: "Prestige", text: "among the top 3 gaming regulators globally" },
                                { title: "UK Access", text: "fully recognized by UK Gambling Commission" },
                                { title: "Banking & PSP Access", text: "Tier-1 banks and PSPs onboard Gibraltar operators" },
                                { title: "Industry Cluster", text: "home to many of the world’s largest gaming firms" },
                                { title: "Crypto Friendly", text: "operators can integrate blockchain payments" }
                            ]
                        }
                    />

                    <HighlightsSection
                        title='Licensing Process'
                        items={
                            [
                                { title: "Pre-Application Consultation", text: "define operator vs supplier model" },
                                { title: "Entity Incorporation", text: "register company in Gibraltar" },
                                { title: "Application Preparation", text: "detailed business plan, AML/KYC policies, IT systems" },
                                { title: "Due Diligence", text: "regulator reviews directors, shareholders, and technical setup" },
                                { title: "Approval & Licensing", text: "typically 6–9 months" }
                            ]
                        }
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "6–9 months",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Setup Costs",
                                description: "from GBP 60,000+ (legal & application).",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Capital Requirement",
                                description: "GBP 100k–500k depending on size.",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Annual Costs",
                                description: "compliance audits, license fees, local office.",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Specialists in Tier-1 gaming licensing" },
                                { text: "End-to-end support: incorporation, GGC applications, compliance manuals" },
                                { text: "Partnerships with banks, PSPs, and affiliate networks" },
                                { text: "Comparative insights: Gibraltar vs Malta vs Isle of Man vs Curaçao" },
                                { text: "Long-term compliance and renewal support" }
                            ]
                        }/>

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA title='Looking for a Tier-1 iGaming license?'
                         description=
                             "<b>Gibraltar</b> offers one of the world’s <b>most prestigious online gambling licenses</b>, trusted by <b>banks, investors, and regulators worldwide</b>."
                         buttonText='Book a Gibraltar iGaming License Consultation →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Why Gibraltar over Malta or Isle of Man?",
        content: [
            { type: "answer", text: "Gibraltar offers UK access, strong insurance sector support, and a cluster of Tier-1 operators." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "6–9 months." },
        ],
    },
    {
        question: "Can Gibraltar license cover multiple products?",
        content: [
            { type: "answer", text: "Yes — one license covers casino, sportsbook, poker, and lottery." },
        ],
    },
    {
        question: "Can crypto casinos operate with a Gibraltar license?",
        content: [
            { type: "answer", text: "Yes — with AML/KYC and responsible gambling compliance." },
        ],
    },
    {
        question: "Is it expensive?",
        content: [
            { type: "answer", text: "Yes — but it delivers unmatched Tier-1 credibility." },
        ],
    },
];

const testimonialsData =
    [
        {
            quote: "We chose Gibraltar for our casino because of its UK recognition. Offshore Advisory managed the full licensing process.",
            author: "Anthony M.",
            role: "Casino Operator"
        },
        {
            quote: "Our sportsbook gained Tier-1 status with a Gibraltar license. Offshore Advisory guided us from setup to compliance.",
            author: "Maria S.",
            role: "Betting CEO"
        }
    ]
;